import { Component, inject } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { NotificationService, ToastType } from '../../core/services/notification.service';

/**
 * トースト通知の表示コンテナ。
 * アプリのルート（router-outlet の隣）に 1 つだけ配置し、
 * NotificationService が保持するトーストを画面右上にスタック表示する。
 */
@Component({
  selector: 'app-toast-container',
  imports: [LucideAngularModule],
  templateUrl: './toast-container.html',
})
export class ToastContainer {
  private readonly notification = inject(NotificationService);

  /** 表示中のトースト一覧 */
  readonly toasts = this.notification.toasts;

  /** トーストを閉じる */
  dismiss(id: number): void {
    this.notification.dismiss(id);
  }

  /** 種別ごとのアイコン名 */
  toastIcon(type: ToastType): string {
    switch (type) {
      case 'success':
        return 'circle-check';
      case 'error':
        return 'circle-alert';
      default:
        return 'info';
    }
  }

  /** 種別ごとの配色クラス */
  toastClass(type: ToastType): string {
    switch (type) {
      case 'success':
        return 'border-emerald-200 bg-emerald-50 text-emerald-800';
      case 'error':
        return 'border-red-200 bg-red-50 text-red-700';
      default:
        return 'border-brand-sky bg-blue-50 text-brand-navy';
    }
  }
}
